import type {TypedJob} from "../../../metl-models/jobs/JobType.ts";
import type {ScoreResult} from "../model/ScoreResult.ts";

const reworkComponentImplIds: number[] = []
const reworkNegativeScore = -0.25

const missingComponentImplIds: number[] = []
const missingNegativeScore = -10

export function scorerMissingOrReworkComponents(job: TypedJob): ScoreResult<TypedJob> | undefined {
    const reworkable = []
    const missing = []
    Object.values(job.components ?? {}).forEach(x => {
        const implId = x.implementationID
        if(reworkComponentImplIds.includes(implId)) {
            reworkable.push(x)
        } else if(missingComponentImplIds.includes(implId)) {
            missing.push(x)
        }
    })
    const score = (reworkable.length * reworkNegativeScore) + (missing.length * missingNegativeScore)
    if(score !== 0) {
        return {
            scorerId: "MISSING_OR_REWORK_COMPONENTS",
            score,
            scoredObject: job
        }
    }
}